import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=6670618e&scoped=true"
import script from "./RatingDisplay.vue?vue&type=script&lang=js"
export * from "./RatingDisplay.vue?vue&type=script&lang=js"
import style0 from "./RatingDisplay.vue?vue&type=style&index=0&id=6670618e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670618e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ThemeStoresMobileIosComments: require('/app/components/ThemeStores/Mobile/Ios/Comments.vue').default})
